import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../storage.service';
import { TotemService } from '../totem.service';
import { Location } from '@angular/common';
import { AnalyticsService } from '../services/analytics.service';

@Component({
  selector: 'app-evento-detalle',
  templateUrl: './evento-detalle.component.html',
  styleUrls: ['./evento-detalle.component.css']
})
export class EventoDetalleComponent implements OnInit {
  id: number;
  evento: any;
  tienda: any;
  public actual: string = '';
  subscription;
  constructor(private totemService: TotemService, private route: ActivatedRoute,
              private router: Router, private storageService: StorageService, private location: Location,
              private analytics: AnalyticsService) { 

                this.subscription = this.totemService.getLanguage().subscribe(language => {
                    this.actual = language;
                    this.obtenetEventos();
                });
               
            
  }

  ngOnInit() {
    this.obtenerEvento();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  async obtenerEvento() {
    try {
      this.id = parseInt(this.route.snapshot.paramMap.get('id'));
      this.evento = [];
      
      this.actual = this.totemService.getLanguageact();
      console.log('actual',this.actual);
      await this.totemService.geteventos(this.actual).toPromise().then((res: any) => {
        console.log('res',res)
        this.evento = res.find(evento => evento.eve_id === this.id);
        console.log(this.evento);  
        if (this.evento) { this.enviarAnalyticsEvento(this.evento); }
        this.obtenerTienda();
      });
    } catch (err) {
      console.log(err);
    }
  }
  async obtenetEventos() {
    const eventoslist = await this.totemService.geteventos(this.actual).subscribe(eventos => {
      const eventes = eventos.filter(evento => evento.tipo_evento === 'Evento' || evento.tipo_evento === 'Panorama' && !!evento.publicado);
      
      console.log({eventes});
    });
  }
  async obtenerTienda() {
    try {
      await this.totemService.obtenerTiendasOrdenadas('es').then((res: any) => {
        if(this.evento.tipo_evento === 'Ofertas'){
          this.tienda= this.evento.tienda;
        }
        else{
          this.tienda = res.find(tienda => tienda.punto_interes === this.evento.punto_interes);
        }
        console.log(this.tienda);
      })
    } catch (err) {
      console.log(err);
    }
  }

  async iniciarRuta() {
    if(this.evento.tipo_evento === 'Ofertas'){
      await this.storageService.setDestino(this.tienda.puntoInteres.toString(), 'tiendas');
    }
    else{
      await this.storageService.setDestino(this.tienda.punto_interes.toString(), 'tiendas');
    }
    this.router.navigate(['donde-quiero-ir']);
  }

  getTranslation(key: string) {
    const word = this.totemService.getTranslation(key);
    if (word){
      return word[0].texto_descripcion;
    }
  }
  public goBack() {
    this.location.back();
  }

  private enviarAnalyticsEvento(evento: any) {
    if (!evento) { return; }
    const nombre = evento.titulo || evento.nombre || 'Evento';
    const tipo = evento.tipo_evento;

    // page + seccion
    this.analytics.sendSectionView('Eventos');
    this.analytics.sendPageView('/eventos/' + evento.eve_id, 'Evento: ' + nombre, {
      event_id: evento.eve_id,
      event_name: nombre,
      event_type: tipo
    });

    // evento principal (categoria = tipo de evento, id = eve_id)
    this.analytics.sendEventView(nombre, tipo, evento.eve_id);
  }

}
